<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <form [formGroup]="form.formGroup">

    <div class="pb-5 field" >
      <div class="flex items-center">
        <p-checkbox
          [formControlName]="form.formControlNames.useMudPits"
          inputId="useMudPits"
          binary="true"
          (onChange)="this.useMudPits = $event.checked;"
        ></p-checkbox>
        <label for="useMudPits" class="ml-2">Circulate through Mud Pits</label>
      </div>
    </div>

    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">Operation Details</p-tab>
        @if (showDrillPipeData) {
        <p-tab value="1">Landing String
          @if (drillpipeMissing) {
          <i class="validation-error pi pi-exclamation-circle pl-1"
            pTooltip="Landing string not specified."></i>
          }
        </p-tab>
        }
        @if (showRiser) {
        <p-tab value="2">Riser
          @if (form.formGroup.controls?.insideDiameter.invalid || form.formGroup.controls?.outsideDiameter.invalid) {
          <i class="validation-error pi pi-exclamation-circle pl-1"
            pTooltip="Operation not saved, some required inputs not specified."></i>
          }
        </p-tab>
        }
        <p-tab value="3">Other</p-tab>
        @if (useMudPits) {
        <p-tab value="4">Mud Pits
          @if (form.formGroup.controls.mudPits.invalid) {
          <i
            class="validation-error pi pi-exclamation-circle pl-1"
            pTooltip="Operation not saved, double check Mud Pit inputs."
          ></i>
          }
        </p-tab>
        }
      </p-tablist>
      <p-tabpanels class="pl-4 pr-2">
        <p-tabpanel value="0">

          <div class="flex flex-wrap gap-4">

            <!-- Left Column -->
            <div class="flex flex-col flex-1 min-w-[150px] space-y-2">

              <div class="flex flex-col">
                <label for="fluids">Lead Slurry</label>
                <p-select filter filterBy="state.name" [disabled]="isReadOnly" [options]="slurries"
                  optionLabel="state.name"
                  [formControlName]="form.formControlNames.leadSlurry"
                  dataKey="id" appendTo="body" tooltipPosition="top"
                  showDelay="100" hideDelay="500">
                  <ng-template pTemplate="selectedItem">
                    {{ form.formGroup.value.leadSlurry?.state.name }}
                  </ng-template>
                  <ng-template let-leadSlurry pTemplate="item">
                    {{ leadSlurry?.state.name }}
                  </ng-template>
                </p-select>
              </div>

              <p-fieldset class="cementing">
                <ng-template pTemplate="header">
                  <div class="flex items-center p-1">
                    <input type="checkbox" [disabled]="isReadOnly" [checked]="form.formGroup.controls.length.value > 0" (change)="onTailChange($event)" id="tailSlurry" />
                    <label for="tailSlurry" class="ml-2">Tail Slurry</label>
                  </div>
                </ng-template>
                <div [class.opacity-50]="form.formGroup.controls.length.value == 0" [class.pointer-events-none]="form.formGroup.controls.length.value == 0" class="flex flex-col">
                  <label for="fluids">Slurry</label>
                  <p-select filter filterBy="state.name" [disabled]="isReadOnly" [options]="slurries"
                    optionLabel="state.name"
                    [formControlName]="form.formControlNames.slurry" dataKey="id" appendTo="body" tooltipPosition="top"
                    >
                    <ng-template pTemplate="selectedItem">
                      {{ form.formGroup.value.slurry?.state.name }}
                    </ng-template>
                    <ng-template let-slurry pTemplate="item">
                      {{ slurry?.state.name }}
                    </ng-template>
                  </p-select>
                </div>

                <div [class.opacity-50]="form.formGroup.controls.length.value == 0" [class.pointer-events-none]="form.formGroup.controls.length.value == 0" class="flex flex-col">
                  <label for="length">Length</label>
                  <p-inputgroup>
                    <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.length" />
                    <p-inputgroup-addon>{{ longLengthUnit }}</p-inputgroup-addon>
                  </p-inputgroup>
                @if (form.formGroup.controls.length.invalid) {
                  <p class="validation-error">
                    Allowed range: 0 - {{ cementLength }} {{ longLengthUnit }}
                  </p>
                }
                </div>
              </p-fieldset>

              <div class="flex flex-col">
                <label for="fluids">Drilling Fluid</label>
                <p-select filter filterBy="state.name" [disabled]="isReadOnly" [options]="fluids"
                  [formControlName]="form.formControlNames.drillingFluid" 
                  optionLabel="state.name"
                  dataKey="id" appendTo="body"
                  tooltipPosition="top">
                  <ng-template pTemplate="selectedItem">
                    {{ form.formGroup.value.drillingFluid?.state.name }}
                  </ng-template>
                  <ng-template let-drillingFluid pTemplate="item">
                    {{ drillingFluid?.state.name }}
                  </ng-template>
                </p-select>
              </div>

              <div class="flex flex-col">
                <label for="displacementRate">Displacement Rate</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.displacementRate" />
                  <p-inputgroup-addon>{{standardFluidFlowUnit}}</p-inputgroup-addon>
                </p-inputgroup>
                @if (form.formGroup.controls.displacementRate.value && form.formGroup.controls.displacementRate.invalid) {
                  <p class="validation-error">
                    Allowed range: {{ displacementRateValidation.min }} - {{ displacementRateValidation.max }} {{standardFluidFlowUnit }}
                  </p>
                }
              </div>

              @if (isSubsea && currentTubularIndex > 0) {
              <div class="pt-3">
                <p-checkbox
                    size="small" 
                    [formControlName]="form.formControlNames.includeRiser"
                    inputId="includeRiser"
                    binary="true"
                    (onChange)="hasRiserChange();"
                  ></p-checkbox>
                  <label class="pl-2" for="includeRiser">Include Riser</label>
              </div>
              }

            </div>

            <!-- Right Column -->
            <div class="flex flex-col flex-1 min-w-[150px] space-y-2">
              <div class="flex flex-col">
                <label for="slurryPumpRate">Slurry Pump Rate</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.slurryPumpRate" />
                  <p-inputgroup-addon>{{ slurryFlowUnit }}</p-inputgroup-addon>
                </p-inputgroup>
                @if (form.formGroup.controls.slurryPumpRate.value && form.formGroup.controls.slurryPumpRate.invalid) {
                  <p class="validation-error">
                    Allowed range: {{ slurryFlowRateValidation.min }} - {{ slurryFlowRateValidation.max }} {{ slurryFlowUnit }}
                  </p>
                }
              </div>

              <div class="flex flex-col">
                <label for="slurryInletTemperature">Slurry Inlet Temperature</label>
                @if (!useMudPits) {
                  <p-inputgroup>
                    <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.slurryInletTemperature" />
                    <p-inputgroup-addon>{{ tempUnit }}</p-inputgroup-addon>
                  </p-inputgroup>
                  @if (form.formGroup.controls.slurryInletTemperature.value && form.formGroup.controls.slurryInletTemperature.invalid) {
                    <p class="validation-error">
                      Allowed range: {{ this.temperatureValidation.min }} - {{ this.temperatureValidation.max }} {{ tempUnit }}
                    </p>
                  }
                }

                @if (useMudPits) {
                  <input type="number" pInputText placeholder="Mud Pits enabled" [disabled]="true" />
                }
              </div>

              <div class="flex flex-col">
                <label for="cementSetTime">Time to 50psi 'Right Angle' set:</label>
                <label for="cementSetTime">Cement Set Time</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.cementSetTime" />
                  <p-inputgroup-addon>hr</p-inputgroup-addon>
                </p-inputgroup>
                @if (form.formGroup.controls.cementSetTime.value && form.formGroup.controls.cementSetTime.invalid) {
                  <p class="validation-error">
                    Allowed range: 0 - 1000 hr
                  </p>
                }
              </div>

              <p-fieldset legend="Displacement Fluid">

                <div class="flex flex-col space-y-2">
                  <div class="flex flex-col">
                    <label for="fluids">Fluid</label>
                    <p-select resetFilterOnHide="true" filter filterBy="state.name" [disabled]="isReadOnly" [options]="fluids"
                      optionLabel="state.name" 
                      [formControlName]="form.formControlNames.fluid"
                      dataKey="id" appendTo="body" tooltipPosition="top" >
                      <ng-template pTemplate="selectedItem">
                        {{ form.formGroup.value.fluid?.state.name }}
                      </ng-template>
                      <ng-template let-fluid pTemplate="item">
                        {{ fluid?.state.name }}
                      </ng-template>
                    </p-select>
                  </div>

                  <div class="flex flex-col">
                    <label for="inletTemperature">Inlet Temperature</label>
                    <p-inputgroup>
                      <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.inletTemperature" />
                      <p-inputgroup-addon>{{ tempUnit }}</p-inputgroup-addon>
                    </p-inputgroup>
                    @if (form.formGroup.controls.inletTemperature.value && form.formGroup.controls.inletTemperature.invalid) {
                      <p class="validation-error">
                        Allowed range: {{ this.temperatureValidation.min }} - {{ this.temperatureValidation.max }} {{ tempUnit }}
                      </p>
                    }
                  </div>
                </div>

              </p-fieldset>

            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <p class="{{ drillpipeMissing ? 'validation-error' : '' }}">{{ selectedDrillPipe }}</p>
        </p-tabpanel>

        <p-tabpanel value="2">
          <p-fieldset legend="Riser">
            <div class="space-y-2">
              <div class="flex flex-col">
                <label for="outsideDiameter">Outside Diameter</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.outsideDiameter" />
                  <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <div class="flex flex-col">
                <label for="outsideDiameter">Inside Diameter</label>
                <p-inputgroup>
                  <p-inputnumber [minFractionDigits]="1" [formControlName]="form.formControlNames.insideDiameter" />
                  <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
                </p-inputgroup>
              </div>
            </div>
          </p-fieldset>
        </p-tabpanel>

        <p-tabpanel value="3">
          <div class="flex flex-col">
            <label for="pipeRoughness">Pipe Roughness</label>
            <p-inputgroup>
              <p-inputnumber [minFractionDigits]="1" [maxFractionDigits]="6" [formControlName]="form.formControlNames.pipeRoughness" />
              <p-inputgroup-addon>{{ pipeRoughnessUnit }}</p-inputgroup-addon>
            </p-inputgroup>
            @if (form.formGroup.controls.pipeRoughness.invalid) {
              <p class="validation-error">
                Allowed range: {{ pipeRoughnessValidation.min }} - {{ pipeRoughnessValidation.max }} {{ pipeRoughnessUnit }}
              </p>
            }
          </div>
        </p-tabpanel>

        <p-tabpanel value="4">
          @if (useMudPits) {
          <app-mud-pit-details
            [disableMudPits]="!useMudPits"
            [previousOperationMudPits]="previousOperationMudPits"
            [userUnits]="userUnits"
            [formControlName]="form.formControlNames.mudPits"
            [surfaceTemperature]="surfaceTemperature"
          ></app-mud-pit-details>
          }
        </p-tabpanel>
      </p-tabpanels>

    </p-tabs>

  </form>
</app-tool-loader>